import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-ruler",
  "use": "icon-si-glyph-ruler-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-ruler\" id=\"icon-si-glyph-ruler\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1081</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M5,0 L5,16 L13,16 L13,0 L5,0 L5,0 Z M6,2 L8,2 L8,3 L6,3 L6,2 L6,2 Z M6,8 L8,8 L8,9 L6,9 L6,8 L6,8 Z M8,15 L6,15 L6,14 L8,14 L8,15 L8,15 Z M9,12 L6,12 L6,11 L9,11 L9,12 L9,12 Z M9,6 L6,6 L6,5 L9,5 L9,6 L9,6 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-ruler.svg
// module id = G6lP
// module chunks = 62